import { BEST_OFFER_EVENT, FAILURE_EVENT, RECENT_CONTACTS_TXN_TYPE_P2P, RECENT_CONTACTS_TXN_TYPE_PREPAID_BUNDLE, RECENT_CONTACTS_TXN_TYPE_PREPAID_RECHARGE, SELECT_EVENT, SUCCESS_EVENT } from "../data/constants";
import { buyBundle, recharge, REPAY_AIRTIME_LOAN } from "../routes/routeConstants";

export interface ITxnFeePayload {
  data: {
    msisdn: string;
    siNumber: string;
    flowType: string;
    price: string;
    currency: string;
    payerBankId: string;
    payeeBankId: string;
    payeeGrade: string;
    tillno: string;
    subFlowType: string;
    operator: string;
    operatorType: string;
    receivingCountryCode: string;
    atmCode: string;
    agentCode: string;
    isBPFlow: boolean;
    "x-consumer-txn-id": string;
  };

  //fee is the fetched txn fee
  callback: (fee: string) => void
}

export interface IGetLobPayload {
  data: {
    "siNumber": string,
    "flowType": ""
  },
  callback: (isAirtel: boolean, isPostpaidNum: boolean, isBroadband: boolean) => void,
  errorCallback: (errorMsg: string) => void,
  hideLoader?: boolean
}

//saga paylaod
export interface IGetLobPayloadV2 {
  data: {
    "siNumber": string,
    "flowType": ""
  },
  callbackV2: (isPrepaid: boolean) => void,
  errorCallback: (errorMsg: string) => void
}

export interface IRechargePayload {
  data: {
    amount: number;
    requestingMsisdn: string;
    recipientMsisdn: string;
    currencyCode: string;
    currency: string;
    transactionType: string;
    paymentMode: string;
    pin: string;
    recipientName: string;
    isSegmentedBundle: boolean;
    autoRenew: boolean;
  },
  successCallback: (args: any) => void;
  errorCallback: (args: any) => void

}

export interface IBundleBuyPayload {
  data: {
    lob: string;
    siNumber: string;
    amount: string;
    requestingMsisdn: string;
    recipientMsisdn: string;
    validity: string;
    nextRenewalDate: string,
    amountdisplayText: string,
    currencyCode: string,
    currency: string,
    transactionType: string,
    subTransactionType: string,
    paymentMode: string,
    pin?: any;
    recipientName: string,
    isBPFlow: boolean,
    isSegmentedBundle: boolean,
    productCode: string,
    fname: string,
    lname: string,
    autoRenew: boolean,
    bundleName: string;
  },
  successCallback: (args: any) => void;
  errorCallback: (args: any) => void
}

export interface IRecentPhoneNumberParentFuncArgs {
  //customer name
  name: string,
  //amount from recent contacts
  recentContactsTxnAmount?: string
}

export interface IRecentContactsPayload {
  "msisdn": string,
  "count": string,
  "transactionTypes": [TRecentContactsTransactionTypes]
}


export type TRecentContactsTransactionTypes = typeof RECENT_CONTACTS_TXN_TYPE_PREPAID_BUNDLE | typeof RECENT_CONTACTS_TXN_TYPE_PREPAID_RECHARGE | typeof RECENT_CONTACTS_TXN_TYPE_P2P;

export interface IRecentContactsData {
  payeeMsisdn: string,
  payeeName: string,
  amount: string
}

export const FavouritesType = {
  rechargeAirtimeFav: 'rechargeAirtimeFav' as const,
  buyBundleFav: 'buyBundleFav' as const,
  sendMoneyFav: 'sendMoneyFav' as const,
  payBillFav: 'payBillFav' as const
};

export type TFavourites = keyof typeof FavouritesType;

export interface IFavConfig {
  transactionType: string,
  category: string
}

export interface IPurposeData {
  id: number,
  purpose: string
  event: string;
}

export interface ISendMoneyConfig {
  enableMiddleName: boolean;
  isPurposeEnabled: boolean;
  purposeList: IPurposeData[];
  searchType: string;
  amountConfig: {
    [key: string]: {
      regex: string;
    };
  };
}

export type TMode = 'light' | 'dark';


export interface IStyleConfig {
  padding?: string;
  margin?: string;
  fontSize?: string;
  color?: string;
  backgroundColor?: string;
}
export interface IColorConfig {
  light?: {
    textColor?: string;
    backgroundColor?: string;
  },
  dark?: {
    textColor?: string;
    backgroundColor?: string;
  }
}

export interface IBtnStyle {
  label?: string;
  padding?: string;
  margin?: string;
  fontSize?: string;
  colorConfig?: IColorConfig;
}

export interface ISmartcashSecureConfig {
  isEnabled: boolean;
  betaCode?: string;
  otpConfig: {
    resendOtpTimer: number,
    otpLength: number,
  }
  pinConfig: {
    showCloseIcn: boolean;
    pinLength: number;
  }
}

export interface IPGOption {
  betaCode: string;
  name: string;
  isEnabled: boolean;
  publicKey?: string;
  allowedPayOptions?: string[];
  emailConfig: {
    emailRegex: string;
    maxEmailLength: number;
  }
}

export interface IPaymentGatewayConfig {
  PAYSTACK: IPGOption,
  UBA: IPGOption
}

export interface ICustomEventMgmtConfig {
  eventsEnabled: false
}

export interface IConfigSliceProps {
  basicConfig: {
    customerCareNo: string,
    msisdnLength: string,
    backgroundThreadFreq: string,
    currency: string[],
    ussdGSMCode: string,
    ussdAMCode: string,
    otpAttempts: string,
    recentContactsCount: string;
    invalidAMPinStatuses: number[];
    bundleType: any;
    [FavouritesType.rechargeAirtimeFav]: IFavConfig | undefined;
    [FavouritesType.buyBundleFav]: IFavConfig | undefined;
    [FavouritesType.sendMoneyFav]: IFavConfig | undefined;
    [FavouritesType.payBillFav]: IFavConfig | undefined;
    ussdPayBillCode: string;
  };
  transactionLimitConfig: any;
  homeConfig: any;
  homeConfigTimestamp: string;
  balanceConfig: Array<any>;
  launchConfig: {
    isOtpFlowEnable:boolean
    newSendOtpLoaderFlag: boolean;
    isAutoLoginEnable: boolean;
    downloadLink: string,
    phoneCode: string,
    lang: string,
    otpTimer: string,
    msisdnLength: string,
    ga4Id?: string,
    betaUsers: Array<string>,
    allBetaFeatureCodes: string[],
    gsmBalConfigs: IGSMBalConfig[],
    amOptions: Array<Array<string>>,
    version: string,
    disableRightClick: boolean,
    featureMap: any,
    appSettingsConfigs: IAppSettingsConfig[],
    helpAndSupportConfig: {
      contactUsConfigs: IContactUsConfig[],
      findUsOnConfigs: IFindUsOnConfig[]
    },
    buyGoodsConfig: {
      vendorConfigs: {
        code: string,
        operator: string,
        paymentMode: string,
        txnType: string,
        event: string,
        tillConfig: {
          regex: string,
          minLength: number,
          maxLength: number,
          inputMode: "tel" | "search" | "text" | "email" | "url" | "none" | "numeric" | "decimal" | undefined
        },
        amountConfig: {
          [key: string]: {
            min: number,
            max: number,
            regex: string;
          }
        },
        useNickName: boolean
      }[],
      searchText: string;
      enableHint: boolean;
    },
    popularRecharges: number[],
    withdrawCashConfig: {
      agentCodeRegex: string,
      agentCodeMinLength: number,
      agentCodeMaxLength: number,
      agentCodeInputMode: "tel" | "search" | "text" | "email" | "url" | "none" | "numeric" | "decimal" | undefined,
      showAgentCodeField: boolean;
      searchText: string;
      showVerifyBtn: boolean;
      enableHint: boolean;
      agentCodeKey: string;
      amountConfig: {
        [key: string]: {
          regex: string;
        }
      }
    },
    paymentMethodConfig: {
      showDetails: boolean
    },
    MPESAConfig: {
      remainingTimeSecs: number,
      enquiryIntervalMillis: number,
      enquiriesAllowed: number
    },
    showShare: boolean;
    sessionTimeout: number;
    autoLogout: boolean;
    showExitPopup: boolean;
    buyBundleConfig: {
      tabsId: { heading: string, event: string }[],
      bundleEventObj: { [key: string]: Record<ACTION, string> },
      bundleGuestEventObj: { [key: string]: Record<ACTION, string> };
      bundleAllowedCategories: Array<string>,
      bundleAllowedPeriodsWithOrder: Array<string>,
      comboTabCategoriesOrder: Array<string>,
      microSiteConfig: {
        bannerText: string,
        enableBanner: boolean,
        betaCode: string
      }
    },
    payBillsConfig: {
      transactionType: string,
      vendorConfigs: {
        code: string;
        billerCode?: string;
      }[],
      validationConfig: any,
      amountPlaceholder: string
    },
    enableSecureSms: boolean;
    secureSmsNonSupportedBrowsers: ISecureSmsNonSupportedBrowsersConfig[];
    secureSmsTimeout: number,
    secureSmsDelay: number,
    transactionLimConfig: TransactionLimConfig,
    amTransactionHistoryConfig: {
      navTab: {
        data: { heading: string, code: string }[]
      },
      serviceTypes: any
    },
    gsmTxnHistoryConfig: {
      navTab: {
        data: { heading: string, code: string }[],
        endPoint: string
      },
      serviceTypes: any,
      numberOfFetchGSMTransactions: number
    },
    numberOfFetchAMTransactions: number
    supportedBrowsers: any;
    hesupportedBrowsers: any;
    gasupportedBrowsers: any;
    minimumScreenWidth: string;
    noAuthCheckRoutes: string[];
    locateUsLink: string;
    languageConfig: {
      supportedLanguages: { code: string, label: string }[]
    }
    heInitUrl: string;
    autoHeInit: boolean;
    heMandatory: boolean;
    heUnsupportedBrowser: any;
    isHeDisable: boolean;
    heOtpFlowEnable: boolean;
    isTempPinEnabledInOPCO: boolean;
    isDisableOtpPaste: boolean;
    isChangePin: boolean;
    guestConfig: {
      isEnabled: boolean;
      remainingTimeSecs: number;
      enquiryIntervalMillis: number;
      enquiriesAllowed: number;
      transactionLimConfig: any;
      otpPinFlow: {
        isEnable: boolean,
        betaCode: string
      }
    };
    securityQuestions: {
      ansMinLength: number;
      ansMaxLength: number;
    },
    betaFeatureMap: any;
    ussd_am_code: string;
    enableUnlockPin: boolean;
    dualCurrency: {
      usdConversionValue: number;
    }
    amountMaxLength: number;
    showAmBalDecimal: boolean;
    payXEnabled: boolean;
    tipsForSetPin: any;
    enableServerSideTagging: boolean;
    serverSideTaggingUrl: string;
    serverContainerUrl: string;
    addToHomeConfig: {
      enabledForIOS: boolean;
      enabledForAndroid: boolean;
      enableAddToHomeV3: boolean;
      dashboard: {
        addToHomeBtn: IBtnStyle
      };
      addToHomePopUp: {
        addBtn: IBtnStyle;
        otherBtn: IBtnStyle;
      };
    };
    loanConfig: {
      betaCode?: string;
      loanConsentPoints: number[];
      isEnabled: boolean;
      loanType: string;
      historyConfig: {
        navTab: {
          data: { heading: string, code: string, disclaimerKey: string }[]
        },
        numberOfTransaction: number,
        noTransactionFoundDisclaimerKey: string,
        dateFormat: string
      },
      loanCategoryList: Array<string>
      loanCardConfig: ILoanCardConfig
    },
    webEngageLimits: {
      minAMBalance: number;
      minAirtimeBalance: number;
      minDataBalance: number;
      minDataBalanceUnit: string;
      minSMSBalance: number;
      minVoiceBalance: number;
    }
    sendMoneyConfig: ISendMoneyConfig;
    webEngageConfig: {
      isEventsEnabled: boolean;
      isUserAttributeEnabled: boolean;
    },
    webPageConfig: {
      isEnable: boolean;
      isPayBillEnable: boolean;
      sliderArray: Array<number>;
    };
    enableQsg: boolean;
    offlineConfig: {
      isEnable: boolean;
      betaCode: string
    }
    maxScreenWidthOfTablet: number;
    darkModeConfig: {
      isEnable: boolean;
      betaCode: string;
    }
    enableSetPin: boolean;
    enableSetQuestion: boolean;
    showDABalance: boolean;
    extraAirtimeConfig: IExtraAirtimeConfig,
    secureCheckoutConfig: {
      betaCode: string,
      isEnable: boolean
    }
    transactionSummaryConfig: {
      continueBtn: IBtnStyle
    };
    isAutoOTPEnabled: boolean;
    forgotNumberConfig: {
      isEnable: boolean;
      dialerNo: string
    };
    smartcashSecureConfig: ISmartcashSecureConfig
    otherServices: Array<IOtherServicesOptions>;
    dashboardConfig: IDashboardConfig;
    smallDeviceConfig: {
      width: number,
      height: number,
    }
    paymentGatewayConfig: IPaymentGatewayConfig;
    responsiveModeEnable: boolean;
    customEventMgmtConfig: ICustomEventMgmtConfig;
    seoConfig: {
      description: string;
      keywords: string;
    }
    buyAirtimeConfig: {
      amountConfig: {
        [key: string]: {
          regex: string;
        }
      }
    },
    enableMsisdnSpace: boolean;
  },
  userAttribute: string;
}

export interface IBundleResult {
  result: any;
}

export interface ICurrScreen {
  event?: string;
  guestEvent?: string;
  heading: string;
  id: string;
}

export interface IOtherServicesOptions {
  name: string;
  route: string;
  event: string;
  betaCode: string;
  enabled: boolean;
  url: string;
};

export interface IBuyBundleV2 {
  showBestSellerOnly?: boolean;
}

export interface IDashboardConfig {
  showAMCard: boolean,
  showAMTransactionHistoryCard: boolean,
  bestSellerBundleCardConfig: {
    enable: boolean,
    bundleCount: number
  }
}

export interface IExtraAirtimeConfig {
  betaCode: string,
  paymentMethod: IExtraAirtimePaymentMethod
}
export interface IExtraAirtimePaymentMethod {
  airtime: IEAPaymentMethod,
  bundle: IEAPaymentMethod
}

export interface IEAPaymentMethod {
  amPaymentMethod: IEAPaymentMethodData,
  mpesaPaymentMethod: IEAPaymentMethodData
}

export interface IEAPaymentMethodData {
  isEnable: boolean,
  enableForGuest: boolean,
  percentage: any,
  minAmount: number,
  showDescription: boolean,
}

export type IGoodsVendorConfig = IConfigSliceProps["launchConfig"]["buyGoodsConfig"]["vendorConfigs"][0];

export interface IAppSettingsConfig {
  code: string,
  icon: string,
  type: "CLICK" | "CUSTOM_PAGE" | "STATIC_PAGE" | "",
  paramObj: { pageUrl: string };
  isGuest?: boolean;
}

export interface IContactUsConfig {
  code: string,
  icon: string,
  content: string,
  hrefType: "tel" | "mailto" | ""
}

export interface IFindUsOnConfig {
  code: string,
  icon: string,
  url: string
}

export interface ISecureSmsNonSupportedBrowsersConfig {
  osName: string,
  browserName: string
}

export interface IFetchedFav {
  "subCategory": string,
  "amount": string,
  "favouriteValue": {
    "favData": IFavMetaData[]
  },
  "updatedBy": string,
  "nickName": string,
  "partyValue": string,
  "favouriteType": string,
  "favouriteGroup": string,
  "partyType": string,
  "createdOn": string,
  "transactionType": string,
  "unit": string,
  "createdBy": string,
  "referenceNumber": string,
  "id": number
}

export interface IBundleFav extends PartialBy<IFetchedFav, "favouriteValue">, IBundleFavMetaData {

}

export interface IFav extends PartialBy<IFetchedFav, "favouriteValue">, ICommonFavMetaData {

}

export interface IBundleFavMetaData extends ICommonFavMetaData {
  bundleId: string,
  bundleType: string,
  bundleName: string,
  validity: string
}

/**
 * Will be used for meta data common to bundle, recharge and send money favourites
 */
export interface ICommonFavMetaData {

}

export interface ISelectedPack {
  packName: string,
  price: string,
  packId: string,
  validity: string
}

export interface IFavMetaData {
  key: string,
  value: string
}

export type PartialBy<T, K extends keyof T> = Omit<T, K> & Partial<Pick<T, K>>

export interface IGetBetaFeaturesResp {
  featureName: string;
  availabilityType: string;
}

/**
 * Payload received in launch config.
 * Used to render gsm bal card in the dashboard
 */
export interface IGSMBalConfig {
  isEnabled: boolean,
  types: string[],
  footerLabel: string,
  footerRoute: string,
  event: string,
  decimalLimit: any
}

/**
 * A msisdn which MAY contain 0 or phonecode as prefix  
 */
export type PrefixedMsisdn = { value: string };

//location data accepted by payment options page
export interface IPaymentOptionsLocData {
  from: typeof recharge.RECHARGE | typeof buyBundle.BUNDLE_MENU | typeof REPAY_AIRTIME_LOAN
  data: {
    amountPending?: number;
    vendorId?: string;
    subType?: string;
    loanEligible?: boolean;
    loanAvailable?: boolean;
    operator: string;
    amount: string | number,
    txnFee: number,
    // receipientName: string,
    msisdn: string,
    heading: string,
    benefitsName: string;
    benefitsMsg: string;
    productCode?: string;
    paymentMode?: string;
    bundleCategory?: string,
    bundleIsBestOffer?: boolean,
    isGuestUser?: boolean;
    currency?: string;
    otherAmount?: string;
    isLoanDetailsRequired?: boolean,
    isBenifitDetailsRequired?: boolean,
    packName?: string;
    serviceFee?: number;
    extraAirtime?: string;
    tkn?: string
  }
}

/**
 * Payment option received from api
 */
export interface IPaymentOptions {
  "balance": number,
  "name": string,
  "applicable": boolean,
  "minTxnAmount": number,
  "currencyCode": string,
  "paymentType": string
}

/**
 * Fetch payment option request 
 */
export interface IPaymentOptionsReq {
  transactionType: string
}
export type FLOW = "P2P" | "P2PI" | "PREPAID_RECHARGE" | "CASHOUT" | "IS_ENABLED" | "PREPAID_BUY_BUNDLES";

type TransactionLimConfig = Record<FLOW, boolean> & { isEnabled: boolean };

export type ACTION = typeof SUCCESS_EVENT | typeof FAILURE_EVENT | typeof SELECT_EVENT | typeof BEST_OFFER_EVENT;

export interface IOption {
  id?: number | string;
  purpose?: string;
  label?: string;
  question?: string;
  questionId?: string;
  event?: string;
}

export interface CustomDropdownProps {
  options: IOption[];
  selectedOption: IOption;
  onSelect: (selectedOption: IOption) => void;
  isDisable: boolean;
  optionKey: keyof IOption;
  heading?: string;
  selectedHeading?: string;
  label?: string;
  dropDownClass?: string;
  optionClass?: string;
}

export interface ISuccessLocationData {
  isSendMoneySuccess?: boolean;
  isBuyBundleSuccess?: boolean;
  bundleFavMetaData?: IBundleFavMetaData;
  rechargeFavMetaData?: ICommonFavMetaData;
  sendMoneyFavMetaData?: ICommonFavMetaData;
  isRechargeSuccess?: boolean;
  isFavSelected: boolean;
  msg: string,
  msisdn: string,
  amount: string,
  isBundleBuy?: boolean;
  isPayBillSuccess?: boolean;
  payBillFavMetaData?: any
}

export interface IExtAirData {
  isExtraAirAllow?: any;
  extraAirtimePercentage?: any;
  minAmmount?: any;
  showDescription?: boolean;
  amountPending?: number;
  vendorId?: string;
  subType?: string;
  loanEligible?: boolean;
  loanAvailable?: boolean;
  operator: string;
  amount: string | number,
  txnFee: number,
  // receipientName: string,
  msisdn: string,
  heading: string,
  benefitsName: string;
  benefitsMsg: string;
  productCode?: string;
  paymentMode?: string;
  bundleCategory?: string,
  bundleIsBestOffer?: boolean,
  isGuestUser?: boolean;
  currency?: string;
  otherAmount?: string;
  isLoanDetailsRequired?: boolean,
  isBenifitDetailsRequired?: boolean,
  packName?: string;
  rechargeType: number | string | undefined;
  paymentType: string | number | undefined;
  extraAirtime?: string | undefined;
  percentage?: any
}

export interface IPropsIcns { fillColor?: string, height?: string, width?: string }

export interface ICompatibility {
  eventType: "" | "resolutionFailed" | "browserNameFailed" | "browserVersionFailed";
}

export type ILoanCardConfig = {
  showLoanSummary: boolean,
  showAirtimeLoanCard: boolean
  showBundleLoanCard: boolean
  showDescriptionInCatList: boolean
  showPayOptLoanCard:boolean
}